import { render, staticRenderFns } from "./CreateJobboardSpec.vue?vue&type=template&id=4ddd47e2"
import script from "./CreateJobboardSpec.vue?vue&type=script&lang=js"
export * from "./CreateJobboardSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports